import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  background: white;
  color: black;
  display: inline-block;
  border-radius: 3px;
  padding: 0.5rem 0;
  margin: 0.5rem 1rem;
  width: 11rem;
  border: 2px solid #3a3a3a;
  outline: none;
`;

export const Button = ({ handleClick, children }) => {
  return (
    <StyledButton onClick={handleClick} primary>
      {children}
    </StyledButton>
  );
};
